module.exports = __webpack_public_path__ + "img/quantum-reconhecimento-facial-homem-200x171.f99eebff.png";